 import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'
import './styles/index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {createBrowserHistory} from 'history'
import configureStore from './store/configureStore'
import registerServiceWroker from './components/common/registerServiceWorker'
import Router from './mainRouter'
import moment from 'moment'
import loginApi from './store/api/login'
import { updateServiceworker } from './store/service-worker-redux'

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({basename: baseUrl})

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState
const store = configureStore(history, initialState)

const rootElement = document.getElementById('root')
let interval = {}

export {history};

let refreshToken = async function () {
    let responseToken = await loginApi.refresh()
    let authToken = responseToken.data
    sessionStorage.setItem('previouspath', history.location.pathname)
    sessionStorage.setItem('token', authToken.token);
    sessionStorage.setItem('expires', authToken.expires);
};

clearInterval(interval)
interval = setInterval(async () => {
    var now = moment(new Date());
    var end = moment(sessionStorage.getItem("expires"));
    var duration = moment.duration(end.diff(now));
    var minutes = duration.asMinutes();
    if (minutes < 1) {
        await refreshToken()
    }
}, 10000)

const onUpdate = () => {
    store.dispatch(updateServiceworker())
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}/>
    </Provider>,
    rootElement)

registerServiceWroker(onUpdate)
